import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import AboutUs from '../views/AboutUs.vue'
import ProductCenter from '../views/ProductCenter.vue'
import StoreOutlets from '../views/StoreOutlets.vue'
import ContactUs from '../views/ContactUs.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
	title:"护工来啦"
  },{
    path: '/about',
    name: 'aboutUs',
    component: AboutUs,
	title:"护工来啦-关于我们"
  },{
    path: '/productCenter',
    name: 'ProductCenter',
    component: ProductCenter,
	title:"护工来啦-服务中心"
  },{
    path: '/storeOutlets',
    name: 'StoreOutlets',
    component: StoreOutlets,
	title:"护工来啦-门店网点"
  },{
    path: '/contactUs',
    name: 'ContactUs',
    component: ContactUs,
	title:"护工来啦-联系我们"
  }
]

const router = new VueRouter({
  routes
})
router.afterEach((to, from) => {
	routes.forEach((item,index)=>{
		if(item.name == to.name){
			setTimeout(()=>{
				document.getElementsByTagName("title")[0].innerText = item.title;
			},30)
		}
	})
})
export default router
